(() => {
  'use strict';
  const parseSize = value => /^W(\d+)\s*\/\s*L(\d+)$/i.exec(value.trim());
  const unique = values => [...new Set(values)].sort((a,b) => Number(a)-Number(b));
  function button(text, label) {
    const el = document.createElement('button');
    el.type = 'button'; el.textContent = text; el.setAttribute('aria-label',label);
    return el;
  }
  function enhanceProduct(root) {
    if (root.dataset.vjReady) return;
    const source = root.querySelector('[data-variant-json]');
    const labelSource = root.querySelector('[data-vj-labels]');
    if (!source || !labelSource) return;
    const variants = JSON.parse(source.value || source.textContent);
    const labels = JSON.parse(labelSource.textContent);
    root.dataset.vjReady = 'true';
    const selects = [...root.querySelectorAll('select[data-variant-input]')];
    const updaters = [];
    if (variants.length < 250) selects.forEach(select => {
      const values = [...select.options].map(o=>o.value);
      const combined = values.length > 0 && values.every(parseSize);
      if (!combined && (values.length > 20 || values.some(v=>v.length > 18))) return;
      const wrapper = select.closest('.variant-wrapper');
      const index = select.dataset.index;
      const valid = value => variants.some(v=>v.available && v[index]===value && selects.every(s=>s===select || v[s.dataset.index]===s.value));
      const container = document.createElement('div');
      container.className = 'vj-size-picker';
      const groups = [];
      function group(title, options, part) {
        const field = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = title; field.append(legend);
        const row = document.createElement('div'); row.className = 'vj-size-options';
        const buttons = options.map(value => {
          const b = button(value, title+' '+(part===1?'W':part===2?'L':'')+value);
          b.dataset.value = value;
          b.addEventListener('click', () => {
            if (combined) {
              const current = parseSize(select.value);
              let next;
              if (part===1) {
                const available = values.filter(v=>parseSize(v)[1]===value && valid(v));
                next = available.find(v=>parseSize(v)[2]===current?.[2]) || available[0];
              } else next=values.find(v=>parseSize(v)[1]===current?.[1] && parseSize(v)[2]===value && valid(v));
              if (!next) return;
              select.value=next;
            } else select.value=value;
            select.dispatchEvent(new Event('change',{bubbles:true}));
            sync();
          });
          row.append(b); return b;
        });
        field.append(row); container.append(field); groups.push({part,buttons});
      }
      if (combined) {
        group(labels.waist,unique(values.map(v=>parseSize(v)[1])),1);
        group(labels.length,unique(values.map(v=>parseSize(v)[2])),2);
        const helper = root.querySelector('[data-vj-size-help]');
        if (helper) container.append(helper.content.cloneNode(true));
      } else group(wrapper.querySelector('label')?.textContent.trim() || select.getAttribute('aria-label') || labels.chooseSize,values,0);
      const chosen = document.createElement('p'); chosen.className='vj-selected-size';
      chosen.setAttribute('aria-live','polite'); container.append(chosen);
      const sync = () => {
        const size = combined ? parseSize(select.value) : null;
        groups.forEach(({part,buttons}) => buttons.forEach(b=>{
          const value = b.dataset.value;
          const selected = combined ? size?.[part]===value : select.value===value;
          b.setAttribute('aria-pressed',String(selected));
          b.disabled = combined ? !values.some(v=>{
            const p=parseSize(v);
            return p[part]===value && (part===1 || p[1]===size?.[1]) && valid(v);
          }) : !valid(value);
          b.title=b.disabled?labels.unavailable:'';
        }));
        chosen.replaceChildren(Object.assign(document.createElement('span'),{className:'vj-selected-size__label',textContent:labels.chosen.replace(/:\s*$/,'')}),Object.assign(document.createElement('strong'),{className:'vj-selected-size__value',textContent:select.value.replace('/', ' / ')}));
      };
      wrapper.append(container);
      wrapper.classList.add('vj-picker-enhanced');
      select.tabIndex=-1; select.setAttribute('aria-hidden','true');
      updaters.push(sync); sync();
    });
    const body=root.querySelector('[data-vj-description-body]');
    const features=root.querySelector('[data-vj-features]');
    if(body && features) {
      const candidates=[...body.querySelectorAll('li,p')].map(e=>e.textContent.trim());
      [/^Pasvorm\s*:/i,/^Taille\s*:/i,/^Materiaal\s*:/i].forEach(pattern=>{
        const value=candidates.find(t=>pattern.test(t) && t.length<115);
        if(value){const span=document.createElement('span');span.textContent=value;features.append(span);}
      });
      features.hidden=!features.children.length;
      const parent=root.querySelector('[data-vj-description]');
      let destination=body;
      const buckets=new Map();
      [...body.childNodes].forEach(node=>{
        if(node.nodeType===1 && (/^H[2-4]$/.test(node.tagName) || /^productspecificaties$/i.test(node.textContent.trim()))){
          const heading=node.textContent.toLowerCase();
          let key=null;
          if(/materiaal|stofcombinatie|onderhoud|wasvoorsch|fabric|care/.test(heading)) key='materials';
          else if(/duurzaam|sustainab/.test(heading)) key='sustainability';
          else if(/specificatie|specification/.test(heading)) key='specifications';
          if(key){
            if(!buckets.has(key)){
              const detail=document.createElement('details');detail.className='vj-detail';
              const summary=document.createElement('summary');summary.textContent=labels[key];
              const content=document.createElement('div');content.className='vj-detail-body rte';
              detail.append(summary,content);parent.append(detail);buckets.set(key,content);
            }
            destination=buckets.get(key);
          } else destination=body;
        }
        if(destination!==body) destination.append(node);
      });
      const carbon=root.querySelector('.vj-sustainability');
      if(carbon && buckets.has('sustainability')){
        buckets.get('sustainability').append(...carbon.querySelector('.vj-detail-body').childNodes);
        carbon.remove();
      }
    }
    const service=root.querySelector('[data-vj-service]');
    const cta=root.querySelector('[data-add-to-cart]');
let sticky=null;
if(cta && !root.dataset.modal?.includes('true')) {
  sticky=document.createElement('div');
  sticky.className='vj-mobile-purchase vj-mobile-purchase--product';sticky.hidden=true;
  const overview=button('',labels.chooseSize);overview.className='vj-mobile-overview';
  const photo=document.createElement('img');photo.className='vj-mobile-photo';photo.alt='';photo.width=48;photo.height=60;photo.loading='lazy';photo.decoding='async';
  const copy=document.createElement('span');copy.className='vj-mobile-copy';
  const title=document.createElement('span');title.className='vj-mobile-title';title.textContent=root.dataset.productTitle || root.querySelector('.product-single__title')?.textContent.trim() || '';
  const details=document.createElement('span');details.className='vj-mobile-details';
  const price=document.createElement('strong');price.className='vj-mobile-price';
  const size=document.createElement('span');size.className='vj-mobile-variant';
  details.append(price,size);copy.append(title,details);overview.append(photo,copy);
  overview.addEventListener('click',()=>{
    const target=root.querySelector('.vj-size-picker') || root.querySelector('.variant-wrapper') || cta;
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    (target.querySelector('button[aria-pressed="true"]:not(:disabled),input:checked,select,button:not(:disabled)') || cta).focus({preventScroll:true});
  });
  const add=button('',cta.textContent.trim());add.className='vj-mobile-add';
  add.addEventListener('click',()=>{if(!cta.disabled)cta.click();});
  sticky.append(overview,add);document.body.append(sticky);
  const firstPhoto=root.querySelector('.starting-slide img.photoswipe__image, [data-product-image-main] img');
  const mobile=matchMedia('(max-width: 768px)');
  const syncVisibility=()=>{
    const r=cta.getBoundingClientRect();
    sticky.hidden=!mobile.matches || r.bottom>0 || cta.getClientRects().length===0;
    document.body.classList.toggle('vj-purchase-visible',!sticky.hidden);
  };
  const updateSticky=()=>{
    price.textContent=root.querySelector('[data-product-price]')?.textContent.trim() || '';
    const chosenInputs=[...root.querySelectorAll('[data-variant-input]')].filter(e=>e.tagName==='SELECT' || e.checked);
    const choice=chosenInputs.map(s=>s.value).join(' / ');
    size.textContent=choice || labels.chooseSize;
    size.hidden=!choice || choice==='Default Title';
    overview.setAttribute('aria-label',[title.textContent,price.textContent,size.hidden?'':size.textContent,labels.chooseSize].filter(Boolean).join(', '));
    const variantId=root.querySelector('select[name="id"],input[name="id"]')?.value;
    const variant=variants.find(v=>String(v.id)===String(variantId));
    const src=variant?.featured_image?.src || firstPhoto?.currentSrc || firstPhoto?.src;
    if(src){const url=new URL(src,location.href);url.searchParams.set('width','120');if(photo.getAttribute('src')!==url.href)photo.src=url.href;photo.hidden=false;}else photo.hidden=true;
    add.textContent=root.querySelector('[data-add-to-cart-text]')?.textContent.trim() || cta.textContent.trim();
    add.setAttribute('aria-label',add.textContent+' — '+title.textContent);
    add.disabled=cta.disabled || cta.getAttribute('aria-disabled')==='true' || cta.classList.contains('btn--loading');
    add.setAttribute('aria-busy',String(cta.classList.contains('btn--loading')));
  };
  const observer=new IntersectionObserver(syncVisibility,{threshold:[0,1]});observer.observe(cta);
  let visibilityFrame;
  const requestVisibility=()=>{if(mobile.matches && !visibilityFrame)visibilityFrame=requestAnimationFrame(()=>{visibilityFrame=null;syncVisibility();});};
  window.addEventListener('scroll',requestVisibility,{passive:true});
  window.addEventListener('resize',requestVisibility,{passive:true});
  mobile.addEventListener('change',syncVisibility);
  new MutationObserver(updateSticky).observe(cta,{attributes:true,childList:true,subtree:true});
  const priceNode=root.querySelector('[data-product-price]');
  if(priceNode)new MutationObserver(updateSticky).observe(priceNode,{childList:true,subtree:true,characterData:true});
  updaters.push(updateSticky);updateSticky();syncVisibility();
}

    root.addEventListener('variantChange',event=>{
      updaters.forEach(update=>update());
      const variant=event.detail.variant;
      if(service) service.querySelector('[data-vj-shipping]').textContent=variant && service.dataset.currency==='EUR' && variant.price>=7000 ? labels.freeShipping : labels.shippingThreshold;
      requestAnimationFrame(()=>updaters.forEach(update=>update()));
    });
  }
  const init=()=>document.querySelectorAll('.vj-product').forEach(enhanceProduct);
  document.addEventListener('page:loaded',init);
  document.addEventListener('DOMContentLoaded',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('click',event=>{
    document.querySelectorAll('.vj-facet[open]').forEach(detail=>{if(!detail.contains(event.target)) detail.open=false;});
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('.vj-facet[open]').forEach(detail=>{detail.open=false;detail.querySelector('summary').focus();});
  });
})();


(() => {
  'use strict';
  const cleanups=new WeakMap();
  function init(root){
    const slider=root.querySelector('[data-product-photos]');
    const gallery=root.querySelector('.product__photos');
    const host=root.querySelector('.product__main-photos');
    const source=root.querySelector('[data-vj-labels]');
    if(!slider || !gallery || !host || !source || cleanups.has(root))return;
    const instance=()=>window.Flickity?.data(slider);
    if(!instance() || instance().cells.filter(c=>c.element.querySelector('[data-product-image-main] img')).length<2)return;
    const labels=JSON.parse(source.textContent);
    if(!labels.galleryPlay || !labels.galleryPause)return;
    const controller=new AbortController(),signal=controller.signal;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:768px)'),connection=navigator.connection;
    const economical=()=>Boolean(connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || ''));
    const pause=document.createElement('button');pause.type='button';pause.className='vj-gallery-pause';
    const icon=document.createElement('span');icon.setAttribute('aria-hidden','true');
    const caption=document.createElement('span');pause.append(icon,caption);
    host.classList.add('vj-fade-host');
    let stopped=reduced.matches || economical(),visible=false,hover=false,busy=false,timer,token=0,overlay,animation;
    function update(){icon.textContent=stopped?'▶':'Ⅱ';caption.textContent=stopped?labels.galleryPlay:labels.galleryPause;pause.setAttribute('aria-label',stopped?labels.galleryPlayLabel:labels.galleryPauseLabel);}
    function clear(){clearTimeout(timer);timer=null;}
    function cancel(){token++;clear();animation?.cancel();animation=null;overlay?.remove();overlay=null;}
    function currentImage(){return instance()?.selectedElement?.querySelector('[data-product-image-main] img');}
    function eligible(){return root.isConnected && !signal.aborted && !stopped && !hover && visible && !document.hidden && currentImage()?.complete && currentImage()?.naturalWidth && !document.querySelector('.pswp--open,.drawer--is-open,.modal--is-active');}
    function schedule(){clear();update();if(eligible() && !busy)timer=setTimeout(advance,mobile.matches?7000:6000);}
    function stop(){stopped=true;cancel();update();}
    function ready(img){
      img.loading='eager';
      if(img.complete)return img.naturalWidth?Promise.resolve():Promise.reject(new Error('image'));
      return new Promise((resolve,reject)=>{
        let timeout;
        const finish=event=>{clearTimeout(timeout);img.removeEventListener('load',finish);img.removeEventListener('error',finish);signal.removeEventListener('abort',abort);event.type==='load'?resolve():reject(new Error('image'));};
        const abort=()=>finish({type:'abort'});
        img.addEventListener('load',finish,{once:true});img.addEventListener('error',finish,{once:true});signal.addEventListener('abort',abort,{once:true});timeout=setTimeout(abort,10000);
      });
    }
    async function advance(){
      if(!eligible() || busy){schedule();return;}
      const f=instance(),current=f.selectedIndex,old=currentImage(),request=token;
      let next=current;
      for(let n=1;n<f.cells.length;n++){
        const i=(current+n)%f.cells.length,img=f.cells[i].element.querySelector('[data-product-image-main] img');
        if(img){const w=Number(img.getAttribute('width')) || img.naturalWidth,h=Number(img.getAttribute('height')) || img.naturalHeight;if(w && h && Math.abs(w/h-old.naturalWidth/old.naturalHeight)<.02){next=i;break;}}
      }
      if(next===current){stop();return;}
      const img=f.cells[next].element.querySelector('[data-product-image-main] img');
      busy=true;
      try{
        await ready(img);await img.decode().catch(()=>{});
        if(request!==token || !eligible() || f.selectedIndex!==current)return;
        overlay=document.createElement('div');overlay.className='vj-fade-overlay';overlay.setAttribute('aria-hidden','true');
        const clone=document.createElement('img');clone.src=old.currentSrc || old.src;clone.alt='';clone.width=old.naturalWidth;clone.height=old.naturalHeight;
        overlay.append(clone);host.append(overlay);
        f.select(next,false,true);
        animation=overlay.animate([{opacity:1},{opacity:0}],{duration:reduced.matches?0:500,easing:'ease-in-out',fill:'forwards'});
        await animation.finished;
      }catch(_){if(request===token)stop();}
      finally{overlay?.remove();overlay=null;animation=null;busy=false;schedule();}
    }
    const on=(element,type,fn)=>element.addEventListener(type,fn,{signal});
    on(pause,'click',()=>{cancel();stopped=!stopped;if(!stopped)hover=false;schedule();});
    on(gallery,'pointerdown',e=>{if(!pause.contains(e.target))stop();});
    on(gallery,'focusin',e=>{if(!pause.contains(e.target))stop();});
    on(host,'pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;cancel();}});
    on(host,'pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;schedule();}});
    on(root,'variantChange',stop);
    on(document,'visibilitychange',()=>{cancel();schedule();});
    on(reduced,'change',()=>{if(reduced.matches)stop();});
    if(connection)on(connection,'change',()=>{if(economical())stop();});
    const observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting && entry.intersectionRatio>=.4;if(!visible)cancel();schedule();},{threshold:[0,.4]});observer.observe(slider);
    const first=currentImage();if(first && !first.complete)first.addEventListener('load',schedule,{once:true,signal});
    cleanups.set(root,()=>{stopped=true;cancel();controller.abort();observer.disconnect();pause.remove();host.classList.remove('vj-fade-host');cleanups.delete(root);});
    host.append(pause);update();
  }
  const start=()=>document.querySelectorAll('.vj-product[data-modal="false"]').forEach(init);
  document.addEventListener('page:loaded',start);document.addEventListener('DOMContentLoaded',start);document.addEventListener('shopify:section:load',start);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.vj-product').forEach(root=>cleanups.get(root)?.()));
  if(document.readyState!=='loading')start();
})();
